import jwtInterceptor from "./jwtInterceptor";
import {ELASTIC_ZONE_ENDPOINTS} from "../utils/api";
class ZoneService {

    async getAllZones() {
        const response = await jwtInterceptor.get(ELASTIC_ZONE_ENDPOINTS.getDistinctZone);
        return response.data.data;
    }
}

export  const zoneService = new ZoneService();